import React from "react";
import { Body2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { LabelItem } from "./LabelItem";

const MAX_SHOWN_LABELS = 8;

const LabelItems = ({ labels }) => {
  let showAsDot = false;
  let restLabelsNum = 0;

  if (labels.length > 2) {
    showAsDot = true;
  }

  if (labels.length > MAX_SHOWN_LABELS) {
    if (labels.length > 99) {
      restLabelsNum = 99;
    } else {
      restLabelsNum = labels.length - MAX_SHOWN_LABELS;
    }

    labels = labels.slice(0, MAX_SHOWN_LABELS - 1);
  }

  return (
    <>
      {labels.map((id, index) => (
        <LabelItem
          labelId={id}
          showAsDot={showAsDot}
          key={index}
        />
      ))}
      {restLabelsNum > 0 ? (
        <Body2
          className="tw-ml-0.5"
          weight="bold"
        >
          +{restLabelsNum}
        </Body2>
      ) : null}
    </>
  );
};

LabelItems.propTypes = {
  labels: PropTypes.array.isRequired,
};

export default LabelItems;
